import { PayHeader } from "../Paymentheader/PayHeader";
import "./credit.css";
import { Button, Card, Result, message } from "antd";
import { useSelector,useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axiosInHealth from "../../Redux/axios/AxiosInHealth";
import { useState,useEffect } from "react";
import { KycHealth,PdfHealth } from "../../Redux/actions/NumHealth";
import axiosInCar from "../../Redux/axios/AxiosInCar";
export const HealthCredit = () => {
  const dispatch = useDispatch()
  const SQQData = useSelector((state) => state?.common?.selectedQuote);
  const healthInsurId = useSelector((state) => state?.healthdetail?.healthnum);
  let PolicyDwnld = useSelector((state) => state?.healthdetail?.createProposal?.data);
  let KYCData = useSelector((state) => state?.healthdetail?.KycStatus?.data);
  let PolicyDwnldCr = useSelector((state) => state?.cardetail?.createProposal?.data);
  let KYCDataCr = useSelector((state) => state?.cardetail?.KycStatus?.data);
  const Route = useSelector((state) => state?.common?.route);
  const [loading, setLoading] = useState(false)
  const history = useHistory();
console.log(Route)
const RouteAp = Route === "digit/health_insurance" ? 'health_insurance' : (Route === "digit/health_insurance" ? 'health_insurance' : null);
 console.log(RouteAp)

  const handleKYC = () => {
    setLoading(true)
    axiosInHealth
    .post(`v1/health_insurances/${healthInsurId?.health_insurance_id}/insurers/${SQQData?.insurer}/kyc_status`)
    .then((res) => { 
        const DPaydata = {
            data: res?.data?.data,
          };
          console.log(DPaydata)
          if(DPaydata?.data?.link) {
            window.open(DPaydata?.data?.link, "_blank");
            dispatch(KycHealth(DPaydata));
          }
          dispatch(KycHealth(DPaydata));
      setLoading(false)
    //   if(DPaydata?.data?.kycReason === "NAME_ADDRESS_MISMATCH" ) {
    //     message.info("Enter your name and address exactly as it appears on your document.")
    //   }
    }).catch((err)=> {
      console.log(err.response)
      message.error(err.response.data.error)
      setLoading(false)
    })
  };
  const handleKYCCar = () => {
    setLoading(true)
    let post = {
      policyNumber: PolicyDwnldCr?.policyNumber,
    }
    axiosInCar.post(`v1/${RouteAp}/kyc_status`, post)
    .then((res) => { 
      // console.log(res)
      let data = res.data
      dispatch(KycHealth(data))
      // console.log(data.data.link)
      if (data.data.link) {
        window.open(data.data.link, "_blank");
      }
      setLoading(false)
    }).catch((err)=> {
      // console.log(err.response)
      message.error(err.response.data.error)
      setLoading(false)
    })
  };
  const handleButton = () => {
    setLoading(true)
    // let post = {
    //   policyId: PolicyDwnld?.applicationId,
    // }
    axiosInHealth
    .post(`v1/health_insurances/${healthInsurId?.health_insurance_id}/insurers/${SQQData?.insurer}/pdf_generation`)
    .then((res) => { 
      // console.log(res)
      let data = res?.data?.data
      console.log(data)
      window.open(data?.proposalPath, "_blank");
      dispatch(PdfHealth(data))
       setLoading(false)
    }).catch((err)=> {
      console.log(err.response.data.error)
      message.error(err.response.data.error.errorMessage)
      setLoading(false)
    })
  };
  const handleButtonCar = () => {
    setLoading(true)
    let post = {
      policyId: PolicyDwnldCr?.applicationId,
    }
    axiosInHealth.post(`v1/${RouteAp}/pdf_generator`, post)
    .then((res) => { 
      // console.log(res)
      let data = res.data
      // console.log(data.data.schedulePath)
      window.open(data.data.schedulePath, "_blank");
      dispatch(PdfHealth(data))
      setLoading(false)
    }).catch((err)=> {
      console.log(err.response.data.error)
      message.error(err.response.data.error.errorMessage)
      setLoading(false)
    })
  };
  return (
    <>
    <PayHeader/>
    {Route === "digit/health_insurance" ? (
      <>
      <div className="row justify-content-center py-3">
    {KYCData?.kycVerificationStatus === "DONE" ? 
    <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
      <Result
      status="success"
      title="You have successfully Verified KYC"
      subTitle={`Quote No: ${PolicyDwnld?.policyNumber}`}
      extra={[
        <Button 
        loading={loading}
        onClick={handleButton}
        type="primary" 
        key="console"
        >
          Download Policy
        </Button>,
      ]}
    />
    </Card>
     : <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
     <Result
      status="warning"
      title="Verify Your KYC Satus"
      subTitle={`Quote No: ${PolicyDwnld?.policyNumber}`}
      extra={[
        <Button 
        loading={loading}
        onClick={handleKYC}
        type="primary" 
        key="console"
        >
          Click to Verify KYC Status
        </Button>,
      ]}
      />
      </Card>
      }
      </div>
      </>
      ): (
        <>
        <div className="row justify-content-center py-3">
    {KYCDataCr?.kycVerificationStatus === "DONE" ? 
    <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
      <Result
      status="success"
      title="You have successfully Verified KYC"
      subTitle={`Quote No: ${PolicyDwnld?.policyNumber}`}
      extra={[
        <Button 
        loading={loading}
        onClick={handleButtonCar}
        type="primary" 
        key="console"
        >
          Download Policy
        </Button>,
      ]}
    />
    </Card>
     : <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
     <Result
      status="warning"
      title="Verify Your KYC Satus"
      subTitle={`Quote No: ${PolicyDwnld?.policyNumber}`}
      extra={[
        <Button 
        loading={loading}
        onClick={handleKYCCar}
        type="primary" 
        key="console"
        >
          Click to Verify KYC Status
        </Button>,
      ]}
      />
      </Card>
      }
      </div>
        </>
      )}
    
      <div className="footter-md-cnfrm">
        <div className="footter-md-1">
          <p>
            Registration No. 742, Registration Code No. IRDA/ DB 797/ 19, Valid
            till 09/06/2024, License category- Direct Broker (Life & General)
          </p>
          <p> solely based on the information received from the insurers.</p>
        </div>
        <div className="footer-md-2">
          <p>@Copyright 2018-2024</p>
          <p>
            <a href="www.VIBE.com">VIBE</a>
          </p>
          <p>All rights reserved</p>
        </div>
      </div>
    </>
  );
};
